import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FaTools, FaHome, FaRedo } from 'react-icons/fa';

const ServerError = ({ onReset }) => (
  <>
    <Helmet>
      <title>Something Went Wrong | HireMeJA</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
  <div className="min-h-[80vh] flex items-center justify-center px-4 bg-gray-50">
    <div className="text-center max-w-md">
      <div className="flex justify-center mb-4">
        <div className="bg-blue-950 text-[#cddd3a] rounded-full w-24 h-24 flex items-center justify-center">
          <FaTools size={40} />
        </div>
      </div>

      <p className="text-7xl font-extrabold text-[#cddd3a] leading-none mb-2">500</p>
      <h1 className="text-2xl font-bold text-blue-950 mb-3">Something Went Wrong</h1>
      <p className="text-gray-500 text-sm leading-relaxed mb-8">
        We hit an unexpected error on our end. Our team has been notified.
        Please try again or return to the homepage.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        {onReset && (
          <button
            onClick={onReset}
            className="inline-flex items-center justify-center gap-2 bg-blue-950 text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#cddd3a] hover:text-blue-950 transition-colors"
          >
            <FaRedo size={13} /> Try Again
          </button>
        )}
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 border-2 border-blue-950 text-blue-950 px-6 py-3 rounded-md text-sm font-semibold hover:bg-blue-950 hover:text-white transition-colors"
        >
          <FaHome size={14} /> Go Home
        </Link>
      </div>
    </div>
  </div>
  </>
);

export default ServerError;
